<template>
    <div>
        <org
            v-if="app.rootNode"
            :rootNode="app.rootNode"
            :app="app"
        >
            <template v-slot:after>
                <router-link to="/s3" class="settings-link">
                    S3 Settings &nbsp; &raquo;
                </router-link>
            </template>
        </org>
    </div>
</template>

<script>
import Org     from '../org/component.vue';

export default {
    props: ['app'],

    components: {
        Org
    },

    mounted() {
        if (!this.app.file) {
            this.$router.push('/');
            return;
        }
    }
};
</script>
